import React, { useEffect, useMemo, useState } from 'react';
import { IoBarChartOutline, IoClose } from 'react-icons/io5';
import { samplePolls } from './pollsData';
import { getOrCreatePollUserId, getVotes } from './pollCookies';
import PollItem from './PollItem';
import './PollsDrawer.css';

const PollsDrawer = () => {
  const [open, setOpen] = useState(false);
  const [votes, setVotes] = useState({});

  useEffect(() => {
    getOrCreatePollUserId();
    setVotes(getVotes());
  }, []);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') setOpen(false);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open]);

  const handleVoteChange = (pollId, optionId) => {
    setVotes((prev) => {
      const next = { ...prev };
      if (optionId) next[pollId] = optionId;
      else delete next[pollId];
      return next;
    });
  };

  const ongoing = useMemo(
    () => samplePolls.filter((p) => p.status === 'ongoing'),
    [],
  );
  const closed = useMemo(
    () => samplePolls.filter((p) => p.status === 'closed'),
    [],
  );

  return (
    <>
      {/*<button
        type="button"
        className="floating-polls-button"
        onClick={() => setOpen(true)}
        aria-label="Polls"
        aria-haspopup="dialog"
        aria-expanded={open}
      >
        <IoBarChartOutline />
      </button>*/}

      <div
        className={`polls-drawer-backdrop ${open ? 'is-open' : ''}`}
        onClick={() => setOpen(false)}
        aria-hidden="true"
      />
      <aside
        className={`polls-drawer ${open ? 'is-open' : ''}`}
        role="dialog"
        aria-modal="true"
        aria-label="Polls"
      >
        <div className="polls-drawer__head">
          <div className="polls-drawer__title">
            <h2>民调</h2>
            <span className="polls-drawer__subtitle">Polls</span>
          </div>
          <button
            type="button"
            className="polls-drawer__close"
            onClick={() => setOpen(false)}
            aria-label="Close"
          >
            <IoClose />
          </button>
        </div>

        <div className="polls-drawer__body">
          <section className="polls-section">
            <h3 className="polls-section__title">
              进行中
              <span className="polls-section__count">{ongoing.length}</span>
            </h3>
            <ul className="polls-list">
              {ongoing.map((poll, i) => (
                <React.Fragment key={poll.id}>
                  <PollItem
                    poll={poll}
                    votedOptionId={votes[poll.id] || null}
                    onVoteChange={handleVoteChange}
                  />
                  {i === 0 && (
                    <li className="poll-ad" aria-label="Advertisement">
                      <span className="poll-ad__label">广告 / Ad</span>
                    </li>
                  )}
                </React.Fragment>
              ))}
            </ul>
          </section>

          <section className="polls-section">
            <h3 className="polls-section__title">
              已结束
              <span className="polls-section__count">{closed.length}</span>
            </h3>
            <ul className="polls-list">
              {closed.map((poll) => (
                <PollItem
                  key={poll.id}
                  poll={poll}
                  votedOptionId={null}
                  onVoteChange={handleVoteChange}
                />
              ))}
            </ul>
          </section>
        </div>
      </aside>
    </>
  );
};

export default PollsDrawer;
